// extracted by mini-css-extract-plugin
export default {"tickerSymbol":"Markets_tickerSymbol__Ask-X","scrollbar":"Markets_scrollbar__3v5RG"};